import { useEffect, useState } from "react";
import { ChangingDirectionType, ChangingParameters } from "../../types";
import { mathCalculationService } from "../../../../shared/services/MathCalculationService";
import { StepChangeSelector } from "../StepChangeSelector";

export function OrderSizeSelector({
    parameters
}: {
    parameters: ChangingParameters;
}) {
    const getDefaultStepValue = (): number => {
        return 0.010;
    }

    const getStepValue = (): number => {
        if (parameters.selectedOrder !== null) {
            return parameters.selectedOrder.sizeStep ?? getDefaultStepValue();
        }

        return getDefaultStepValue();
    }

    const [stepValue, setStepValue] = useState<number>(getStepValue());

    useEffect(() => {
        const selectedOrder = parameters.selectedOrder;

        setStepValue(
            selectedOrder !== null
                ? selectedOrder.sizeStep ?? (
                    0.010
                )
                : 0.010
        );
    }, [parameters.selectedOrder]);

    const handleChange = async (direction: ChangingDirectionType, step: number): Promise<void> => {
        const selectedOrder = parameters.selectedOrder;

        if (selectedOrder === null) {
            return;
        }

        const order = parameters.portfolioItems.find(x => x.internalId === selectedOrder.internalId);

        if (order === undefined)
            return;

        switch (direction) {
            case ChangingDirectionType.Next:
                order.size = mathCalculationService.round(order.size + step, 3);
                break;

            case ChangingDirectionType.Previous:
                order.size = mathCalculationService.round(order.size - step, 3);
                break;
        }

        order.setChangedState();

        await parameters.updateItemInSelectedPortfolio(true, false);
    }

    const handleStepSelectionChange = async (step: number): Promise<void> => {
        const selectedOrder = parameters.selectedOrder;

        if (selectedOrder === null) {
            return;
        }

        const order = parameters.portfolioItems.find(x => x.internalId === selectedOrder.internalId);

        if (order === undefined) {
            return;
        }

        order.sizeStep = step;
        order.setChangedState();

        await parameters.updateItemInSelectedPortfolio(false, false);
    }

    const isDisabled = parameters.selectedOrder === null || parameters.selectedOrder.locked;

    return (
        <StepChangeSelector
            selectedStep={stepValue}
            setSelectedStep={setStepValue}
            stepOptions={[1, 0.1, 0.01, 0.001]}
            disabled={isDisabled}
            buttonContent="L"
            previousTooltipText="Reduce order size"
            nextTooltipText="Increase order size"
            onChange={handleChange}
            onStepSelectionChange={handleStepSelectionChange}
            selectorWidth={65}
        />
    );
}
